import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ReportRetrieveInterface } from "../../../middleware/interfaces/report/report-retrieve-interface";

export const ReportRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const reportRetrieveData: ReportRetrieveInterface = state.data;
      const url = "./php/report/report-retriever-proxy.php";
      await axios
        .post(url, reportRetrieveData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
